import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('programRegistrationStore', Object.keys(state)),
	...mapGetters('programRegistrationStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('programRegistrationStore', Object.keys(actions)),
	...mapMutations('programRegistrationStore', Object.keys(mutations))
};
